import { useTranslation } from 'react-i18next';
import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function HotTopics() {
  const { t } = useTranslation();

  const hotArticles = articles.filter((a) => a.isHot).slice(0, 4);

  return (
    <section id="hot-topics" className="py-14 md:py-18 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            {t('hotTopics.title')}
            <span className="text-accent-500">{t('hotTopics.titleHighlight')}</span>
          </h2>
          <p className="text-foreground-500 text-sm mt-2">{t('hotTopics.subtitle')}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5" data-product-shop="">
          {hotArticles.slice(0, 2).map((article) => (
            <ArticleCard key={article.id} {...article} variant="large" />
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5" data-product-shop="">
          {hotArticles.slice(2, 4).map((article) => (
            <ArticleCard key={article.id} {...article} variant="large" />
          ))}
        </div>
      </div>
    </section>
  );
}